// extracted by mini-css-extract-plugin
export default {"customWidth":"Login_customWidth__Lcof5","defLink":"Login_defLink__4E4+p"};